import { useGetOne } from 'react-admin';
import { MCS } from '@/utils/CONST';

interface Params {
    mcUriId: string | undefined;
}

const useGetMc = ({ mcUriId }: Params) => {
    const { data, isLoading, refetch }: any = useGetOne(
        MCS,
        {
            id: mcUriId,
        },
        { enabled: mcUriId !== undefined && mcUriId !== null },
    );

    return {
        mc: data,
        isLoading,
        refetch,
    };
};

export default useGetMc;
